import React from 'react';
import Policy from './Policy';
import WallifyIcon from './assets/wallify-icon.png';
import { Helmet } from 'react-helmet';

function WallifyIntegrityPolicy() {
  return (
    <div>
      <Helmet>
        <title>Wallify Integrity Policy</title>
        <meta name="description" content="Privacy and security policy for the Wallify wallpaper application." />
      </Helmet>
      <Policy title="Wallify Integrity Policy" icon={WallifyIcon}>
        The purpose of this policy is to clearly state Wallify’s commitment to user privacy and security. Wallify is a simple wallpaper application that does not collect, store, or share any personal user data.<br /><br />

        <strong>No Data Collection:</strong> Wallify does not collect or process any personal data, browsing activity, or device information. The app operates entirely offline and does not track user interactions.<br /><br />

        <strong>No Storage of User Data:</strong> Wallify does not store any user data on its servers or in the cloud. Any wallpapers applied or saved are stored solely on the user's device.<br /><br />

        <strong>No Use of Data:</strong> Wallify does not use any personal data for analytics, marketing, or advertising purposes. The application does not include any tracking mechanisms, nor does it profile users in any way.<br /><br />

        <strong>No Third-Party Data Sharing:</strong> Wallify does not share any data with third parties, including advertisers, analytics providers, or external services.<br /><br />

        <strong>In-App Purchases:</strong> Users can purchase the Pro version of Wallify via Google Play Store. However, Wallify does not store or process any payment details—these transactions are handled securely by Google Play and are not linked to any user data within the app.<br /><br />

        <strong>User Control:</strong> Since Wallify does not store any user data, users do not need to take any action to manage, delete, or request their data.<br /><br />

        <strong>Security:</strong> Wallify follows best practices for application security. Since no data is collected, there is no risk of unauthorized access, leaks, or misuse of personal information.<br /><br />

        <strong>Changes to this Policy:</strong> Wallify may update this policy if necessary, but our core principle remains the same: user privacy is our priority. Any updates will be available in the app’s store listing and on our website.<br /><br />

        By using Wallify, users acknowledge and agree to this policy and its outlined practices.
      </Policy>
    </div>
  );
}

export default WallifyIntegrityPolicy;